<template>
  <cheetah-editor
    v-model="value"
    :set-content="$attrs['set-content']"
    :editor-base-color="$attrs['editor-base-color']"
    :editor-selecting-color="$attrs['editor-selecting-color']"
    :editor-passive-color="$attrs['editor-passive-color']"
    :editor-border-color="$attrs['editor-border-color']"
  />
</template>

<script>
import CheetahEditor from "../../CheetahEditor.vue";
export default {
  components: { CheetahEditor },
  name: "AciklamaEditor",
  props: {
    value: {
      required: true
    }
  },
  watch: {
    value(value) {
      this.$emit("input", value)
    }
  }
};
</script>

<style>
</style>